import Heading from './Heading';

export default {
  title: 'Components/Inputs/Heading',
  component: Heading,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

export const Default = {
  args: { label: 'Heading for Custom Fields' },
};

